/**
 * A new page opens at its top (the user, 2026-10-29: "when opening a page — not always it opens
 * in the top of the page — sometimes it opens in the middle").
 *
 * The window is what scrolls, and the router changes the page under it without moving it, so a
 * page opened from far down a long one started where that one was left. On every NEW address
 * (a link, `navigate`) the window goes back to the top. Back and Forward (`POP`) are left to the
 * browser, which puts you back where you were; a change of the query or hash alone (a filter,
 * `?all=1`, a settings section) is the same page and keeps its place. A page that scrolls to an
 * element of its own does so in its effects, after this one.
 */
import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();
  const type = useNavigationType();
  const first = useRef(true);
  useLayoutEffect(() => {
    // The first page of a visit is the browser's (a reload keeps its place).
    if (first.current) { first.current = false; return; }
    if (type === 'POP') return;
    window.scrollTo(0, 0);
    // The path alone: a query or hash change is the same page, whatever kind of navigation it was.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return null;
}
